import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  background-image: url("../../../assets/backgroundmap.svg");
  background-repeat: no-repeat;
  background-position: center;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 8.6875rem;

  @media (min-width: 1280px) {
    margin-right: 0;
}

@media (min-width: 1440px) {
    margin-right: 8.6875rem;
}
`

export const TextContainer = styled.div`
  display: flex;
  width: 24.875rem;
  flex-direction: column;
  margin-right: 8.6875rem;
  p {
    margin-top: 2rem;
    color: var(--grey-100);
  }
  img {
    position: relative;
    height: 2.3rem;
    margin-right: auto;
  }


@media (min-width: 1280px) {
    img {
      margin-bottom: 2rem;
    }

    h1 {
      font-size: 2.4rem;
      line-height: normal;
    }

    p {
      font-size: 0.95rem;
    }
}

@media (min-width: 1440px) {
    img {
      margin-bottom: 2rem;
    }
    h1 {
      font-size: 3rem;
    }

    p {
      font-size: 1rem;
    }
}
`

export const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  padding: 2.5rem;

  width: 25.125rem;
  height: 26.875rem;
  background: var(--black-200);
  border-radius: 4px;
  a {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    font-size: 14px;
    height: 1rem;
    text-decoration: none;
    color: var(--grey-100);

    &:hover {
      text-decoration: underline;
    }
  }

  div div:last-of-type {
    margin-top: 1rem;
  }
  h2 {
    font-family: DM Sans;
    margin-bottom: 2.5rem;
    font-size: 1.5rem;
    font-weight: medium;
  }
  p {
    color: var(--grey-100);
  }

  button {
    margin-top: 1rem;

    transition: filter 0.4s;

    &:hover {
      filter: brightness(70%);
    }
  }

  input {
    width: 100% !important;
  }
`

export const ForgotPasswordContainer = styled.div`
  padding: 1.3rem 0rem;
`
